// Built on admin/editmode.js and  user/viewemode.js
// Use on WYSIWYG

import 'jquery.md5';
import 'jquery-validation';
/************ ใช้ตรงไหนบ้าง */

import CSSJSON from 'cssjson';
window.CSSJSON = CSSJSON;
import '@loadingio/loading-bar';

console.log('window.CSSJSON.toJSON');
window.CSSJSON.toJSON_MOD = window.CSSJSON.toJSON;
window.CSSJSON.toJSONliteral = function(data) {
    // console.log('CSSto json');
    // console.log(data.replace(/[\r\n]+/img, ''))
    return window.CSSJSON.toJSON_MOD(data.replace(/[\r\n]+/gim, ''));
};

window.CSSJSON.toJSON = function(data) {
    // console.log('CSSto json');
    // console.log(data.replace(/[\r\n]+/img, ''))
    return window.CSSJSON.toJSON_MOD(data.replace(/[\r\n]+/gim, ''));
};
